module.exports = __webpack_public_path__ + "img/search-hero-overflow-cjdr.f7b7b88b.jpg";